import { registerTranslateConfig } from 'lit-translate';

registerTranslateConfig({
  loader: lang => fetch(`../assets/locales/${lang}.json`).then(res => res.json()),
});
